export const errorMessage = {
    "USER_NOT_AUTHENTICATED": "Rất tiếc, số điện thoại của bạn không có trong danh sách.",
    "USER_NOT_FOUND": "Rất tiếc, số điện thoại của bạn không có trong danh sách.",
    "NOT_EXITS_PHONE_NUMBER": "Rất tiếc, số điện thoại của bạn không có trong danh sách.",
    "USER_CANT_ACCESS_AN_EXAM": "Rất tiếc, số điện thoại của bạn không có trong danh sách.",
    "NOT_GRANTED": "Rất tiếc, số điện thoại của bạn không có trong danh sách.",
    "FAIL_TO_CREATE_TOKEN": "Hệ thống xảy ra lỗi trong quá trình xác thực, bạn vui lòng thử lại lần nữa.",
    "GET_PHONE_NUMBER_BY_UUID_ERROR": "Hệ thống xảy ra lỗi trong quá trình xác thực, bạn vui lòng thử lại lần nữa.",
    "TEST_NOT_START": "Chưa đến thời gian làm bài, bạn vui lòng quay lại sau.",
    "TEST_TIME_OUT": "Rất tiếc, đã hết thời gian làm bài.",
    "OUT_OF_TRYTIMES": "Rất tiếc, số lần làm bài của bạn đã hết.",
    "TEST_NOT_EXISTED": "Bài này đang được cập nhật, bạn vui lòng quay lại sau.",
    "TESTS_NOT_FOUND": "Bài này đang được cập nhật, bạn vui lòng quay lại sau.",
    "TEST_NOT_QUESTIONS": "Bài này hiện chưa có câu hỏi, bạn vui lòng quay lại sau.",
    "SOME_THING_IS_WRONG": "Đã xảy ra lỗi, bạn vui lòng quay lại sau.",
    "LESSON_NOT_FOUND": "Bài học đang được cập nhật, bạn vui lòng quay lại sau.",
    "LESSON_NOT_STARTED": "Bài học chưa được bắt đầu, bạn vui lòng quay lại sau.",
    "PREVIOUS_LESSON_NOT_COMPLETE": "Bạn chưa hoàn thành các bài học tiên quyết. Hãy học tập theo đúng lộ trình yêu cầu.",
    "QUESTION_NOT_ENOUGH": "Câu hỏi đang được cập nhật, bạn vui lòng quay lại sau.",
    "ANSWERS_SUBMIT_NULL": "Đáp án rỗng, bạn vui lòng thử lại sau ít phút.",
    "QUESTION_TYPE_NOT_FOUND": "Loại câu hỏi không hợp lệ.",
    "TEST_CODE_NOT_FOUND": "Loại bài thi, bài học không hợp lệ.",
    "TL_CODE_NULL": "T code hoặc L code đang rỗng, bạn vui lòng quay lại sau.",
    "ANONYMOUS_AUTHENTICATION_TOKEN": "Chào bạn! Rất tiếc, số điện thoại của bạn không có trong danh sách.",
    "NO_NETWORK": "Mất kết nối mạng",
};
